import Avatar from "boring-avatars";
import { Id } from "../../data/types";

interface UserCardProps {
  id: Id;
  name: string;
}

export default function UserCard({ id, name }: UserCardProps) {
  return (
    <>
      <div className="wish-bg-light-blue w-min rounded-full p-3">
        <Avatar name={id} size={88} variant={"beam"} />
      </div>

      <div className="H6">{name || <i>Anonymous</i>}</div>
    </>
  );
}
